import "./video-footer.scss";

import {
    AudioChangeAction,
    DialOutOption,
    DialoutState,
    MutedSource,
    RecordingStatus,
    VideoCapturingState,
    Participant
} from "@zoom/videosdk";
import { Button, Tooltip } from "antd";
import React, { MutableRefObject, useCallback, useContext, useEffect, useState } from "react";
import { RecordButtonProps, RecordingButton, getRecordingButtons } from "./recording";
import { SELF_VIDEO_ID, getPhoneCallStatusDescription } from "../video-constants";
import { isAndroidBrowser, isSupportOffscreenCanvas } from "../../../utils/platform";
import { useMount, useUnmount } from "../../../hooks";

import CameraButton from "./camera";
import { IconFont } from "../../../component/icon-font";
import { CellLayout, MediaDevice } from "../video-types";
import MicrophoneButton from "./microphone";
import RecordingContext from "../../../context/recording-context";
import { ScreenShareButton } from "./screen-share";
import ZoomContext from "../../../context/zoom-context";
import ZoomMediaContext from "../../../context/media-context";
import classNames from "classnames";
import { message } from "antd";

import { useLayout } from "../../../../context/LayoutContext";

interface VideoFooterProps {
    className?: string;
    shareRef?: MutableRefObject<HTMLCanvasElement | null>;
    sharing?: boolean;
    isFullScreen?: boolean | null;
    setIsFullScreen: (value: boolean) => void;
    isChangeResolution?: boolean | null;
    setIsChangeResolution: (value: boolean) => void;
    triggerOnPatientConnect?: boolean | null;
    Videolayout: CellLayout[] | null;
}

const isAudioEnable = typeof AudioWorklet === 'function';

const VideoFooter = (props: VideoFooterProps) => {
    const { className, shareRef, sharing } = props;
    const [isStartedAudio, setIsStartedAudio] = useState(false);
    const [isStartedVideo, setIsStartedVideo] = useState(false);
    const [audio, setAudio] = useState('');
    const [isSupportPhone, setIsSupportPhone] = useState(false);
    const [phoneCountryList, setPhoneCountryList] = useState<any[]>([]);
    const [phoneCallStatus, setPhoneCallStatus] = useState<DialoutState>();
    const [isStartedScreenShare, setIsStartedScreenShare] = useState(false);
    const [isMirrored, setIsMirrored] = useState(false);
    const [isMuted, setIsMuted] = useState(false);
    const [activeMicrophone, setActiveMicrophone] = useState('');
    const [activeSpeaker, setActiveSpeaker] = useState('');
    const [activeCamera, setActiveCamera] = useState('');
    const [micList, setMicList] = useState<MediaDevice[]>([]);
    const [speakerList, setSpeakerList] = useState<MediaDevice[]>([]);
    const [cameraList, setCameraList] = useState<MediaDevice[]>([]);
    const { mediaStream } = useContext(ZoomMediaContext);
    const recordingClient = useContext(RecordingContext);
    const [recordingStatus, setRecordingStatus] = useState<'' | RecordingStatus>(
        recordingClient?.getCloudRecordingStatus() || ''
    );

    const { handleOpenAlert } = useLayout();

    const zmClient = useContext(ZoomContext);

    const onCameraClick = useCallback(async () => {
        if (isStartedVideo) {
            console.log(props.Videolayout);
            if (props.Videolayout)
                RestoredVideo(props.Videolayout, null, null);
            await mediaStream?.stopVideo();
            setIsStartedVideo(false);
            props.setIsChangeResolution(false);
        } else {

            if (isAndroidBrowser() || (isSupportOffscreenCanvas() && !mediaStream?.isSupportMultipleVideos())) {
                const videoElement = document.querySelector(`#${SELF_VIDEO_ID}`) as HTMLVideoElement;
                if (videoElement) {
                    // console.log("Start video");
                    await mediaStream?.startVideo({ videoElement });
                }
            } else {
                const startVideoOptions = { hd: true };
                if (mediaStream?.isSupportVirtualBackground()) {
                    Object.assign(startVideoOptions);
                }
                await mediaStream?.startVideo(startVideoOptions);
                if (!mediaStream?.isSupportMultipleVideos()) {
                    const canvasElement = document.querySelector(`#${SELF_VIDEO_ID}`) as HTMLCanvasElement;
                    // console.log("Render video");
                    mediaStream?.renderVideo(canvasElement, zmClient.getSessionInfo().userId, 100, 200, 0, 0, 3);
                }
            }
            setIsStartedVideo(true);
        }
    }, [mediaStream, isStartedVideo, zmClient, props.isChangeResolution]);

    const onCheckClick = useCallback(async () => {
        let participants = zmClient.getAllUser();
        const render = document.querySelector('#video-canvas') as HTMLCanvasElement;
        console.log(props.Videolayout);
        if (isStartedScreenShare) {
            handleOpenAlert(
                "No se puede cambiar la resolución mientras está compartiendo pantalla"
            );
            return;
        }
        else if (participants.length != 2) {
            handleOpenAlert(
                "Solo aplica cuando hay 2 usuarios"
            );
            return;
        }
        else if (!(participants[0].bVideoOn && participants[1].bVideoOn)) {
            handleOpenAlert(
                "Ambos usuarios deben tener la cámara activa"
            );
            return;
        }
        else if (props.isChangeResolution) {
            if (props.Videolayout)
                RestoredVideo(props.Videolayout, participants, render);
        }
        else {
            props.setIsChangeResolution(true);

            await mediaStream?.stopVideo();
            if (isAndroidBrowser() || (isSupportOffscreenCanvas() && !mediaStream?.isSupportMultipleVideos())) {
                const videoElement = document.querySelector(`#${SELF_VIDEO_ID}`) as HTMLVideoElement;
                if (videoElement) {
                    await mediaStream?.startVideo({ videoElement });
                }
            } else {
                const startVideoOptions = { hd: true };
                if (mediaStream?.isSupportVirtualBackground()) {
                    Object.assign(startVideoOptions);
                }
                await mediaStream?.startVideo(startVideoOptions);
                if (!mediaStream?.isSupportMultipleVideos()) {
                    const canvasElement = document.querySelector(`#${SELF_VIDEO_ID}`) as HTMLCanvasElement;
                    mediaStream?.renderVideo(canvasElement, zmClient.getSessionInfo().userId, 100, 200, 0, 0, 3);
                }
            }

            const Image1Width = render.width - 10;
            const Image1Height = render.height - 10;
            let min = 5;
            console.log("width", render);
            if (render.width < 950) {
                min = 3;
            }
            const Image2Width = render.width / min;
            const Image2Height = render.height / min;
            const YHost = Image1Height - Image2Height;
            const XHost = Image1Width - Image2Width;

            await mediaStream?.adjustRenderedVideoPosition(render, participants[1].userId, Image1Width, Image1Height, 0, 0);
            await mediaStream?.adjustRenderedVideoPosition(render, participants[0].userId, Image2Width, Image2Height, 0, YHost);

            await mediaStream?.renderVideo(render, participants[1].userId, Image1Width, Image1Height, 0, 0, 3);
            await mediaStream?.renderVideo(render, participants[0].userId, Image2Width, Image2Height, XHost, 0, 3);
        }

    }, [mediaStream, zmClient, isStartedScreenShare, props.isChangeResolution]);

    const RestoredVideo = async (Videolayout: CellLayout[], participants: Participant[] | null, render: HTMLCanvasElement | null) => {
        if (props.isChangeResolution) {
            if (!participants)
                participants = zmClient.getAllUser();
            if (!render)
                render = document.querySelector('#video-canvas') as HTMLCanvasElement;
            let participant1Height = Videolayout[0].height;
            let participant1Width = Videolayout[0].width;
            let participant1X = Videolayout[0].x;
            let participant1Y = Videolayout[0].y;
            let participant1Quality = Videolayout[0].quality;

            let participant2Height = Videolayout[1].height;
            let participant2Width = Videolayout[1].width;
            let participant2X = Videolayout[1].x;
            let participant2Y = Videolayout[1].y;
            let participant2Quality = Videolayout[1].quality;

            await mediaStream?.adjustRenderedVideoPosition(render, participants[1].userId, participant1Width, participant1Height, participant1X, participant1Y);
            await mediaStream?.adjustRenderedVideoPosition(render, participants[0].userId, participant2Width, participant2Height, participant2X, participant2Y);
            props.setIsChangeResolution(false);
        }
    };

    const onMicrophoneClick = useCallback(async () => {
        if (isStartedAudio) {
            if (isMuted) {
                await mediaStream?.unmuteAudio();
                setIsMuted(false);
            } else {
                await mediaStream?.muteAudio();
                setIsMuted(true);
            }
        } else {
            await mediaStream?.startAudio();
            setIsStartedAudio(true);
        }
    }, [mediaStream, isStartedAudio, isMuted]);

    const handleMuteStopAll = async () => {
        await mediaStream?.muteAudio();
        setIsMuted(true);

        await mediaStream?.stopVideo();
        setIsStartedVideo(false);
    };

    const handleUnmuteAudio = async () => {
        await mediaStream?.unmuteAudio();
        setIsMuted(false);
    };

    const handleShowVideo = async () => {
        await mediaStream?.startVideo({ hd: true });
        setIsStartedVideo(true);
    };

    const onMicrophoneMenuClick = async (key: string) => {
        if (mediaStream) {
            const [type, deviceId] = key.split("|");
            if (type === "microphone") {
                if (deviceId !== activeMicrophone) {
                    await mediaStream.switchMicrophone(deviceId);
                    setActiveMicrophone(mediaStream.getActiveMicrophone());
                }
            } else if (type === "speaker") {
                if (deviceId !== activeSpeaker) {
                    await mediaStream.switchSpeaker(deviceId);
                    setActiveSpeaker(mediaStream.getActiveSpeaker());
                }
            } else if (type === "leave audio") {
                if (audio === "computer") {
                    await mediaStream.stopAudio();
                } else if (audio === "phone") {
                    await mediaStream.hangup();
                    setPhoneCallStatus(undefined);
                }
                setIsStartedAudio(false);
            }
        }
    };

    const onSwitchCamera = async (key: string) => {
        if (mediaStream) {
            if (activeCamera !== key) {
                await mediaStream.switchCamera(key);
                setActiveCamera(mediaStream.getActiveCamera());
            }
        }
    };

    const onMirrorVideo = async () => {
        await mediaStream?.mirrorVideo(!isMirrored);
        setIsMirrored(!isMirrored);
    };

    const onPhoneCall = async (code: string, phoneNumber: string, name: string, option: DialOutOption) => {
        await mediaStream?.inviteByPhone(code, phoneNumber, name, option);
    };

    const onPhoneCallCancel = async (code: string, phoneNumber: string, option: { callMe: boolean }) => {
        if ([DialoutState.Calling, DialoutState.Ringing, DialoutState.Accepted].includes(phoneCallStatus as any)) {
            await mediaStream?.cancelInviteByPhone(code, phoneNumber, option);
            await new Promise((resolve) => {
                setTimeout(() => {
                    resolve(true);
                }, 3000);
            });
        }
        return Promise.resolve();
    };

    const onHostAudioMuted = useCallback((payload) => {
        const { action, source, type } = payload;
        if (action === AudioChangeAction.Join) {
            setIsStartedAudio(true);
            setAudio(type);
        } else if (action === AudioChangeAction.Leave) {
            setIsStartedAudio(false);
        } else if (action === AudioChangeAction.Muted) {
            setIsMuted(true);
            if (source === MutedSource.PassiveByMuteOne) {
                message.info("Host muted you");
            }
        } else if (action === AudioChangeAction.Unmuted) {
            setIsMuted(false);
            if (source === "passive") {
                message.info("Host unmuted you");
            }
        }
    }, []);

    const onScreenShareClick = useCallback(async () => {
        if (!isStartedScreenShare && shareRef && shareRef.current) {
            if (props.Videolayout)
                RestoredVideo(props.Videolayout, null, null);
            await mediaStream?.startShareScreen(shareRef.current);
            setIsStartedScreenShare(true);
        } else if (isStartedScreenShare) {
            await mediaStream?.stopShareScreen();
            setIsStartedScreenShare(false);
        }
    }, [mediaStream, isStartedScreenShare, shareRef]);

    const onPassivelyStopShare = useCallback(({ reason }) => {
        // console.log("passively stop reason:", reason);
        setIsStartedScreenShare(false);
    }, []);

    const onDeviceChange = useCallback(() => {
        if (mediaStream) {
            setMicList(mediaStream.getMicList());
            setSpeakerList(mediaStream.getSpeakerList());
            setCameraList(mediaStream.getCameraList());
            setActiveMicrophone(mediaStream.getActiveMicrophone());
            setActiveSpeaker(mediaStream.getActiveSpeaker());
            setActiveCamera(mediaStream.getActiveCamera());
        }
    }, [mediaStream]);

    const onRecordingChange = useCallback(() => {
        setRecordingStatus(recordingClient?.getCloudRecordingStatus() || "");
    }, [recordingClient]);

    const onDialOutChange = useCallback((payload) => {
        setPhoneCallStatus(payload.code);
    }, []);

    const onRecordingClick = async (key: string) => {
        switch (key) {
            case "Record": {
                await recordingClient?.startCloudRecording();
                break;
            }
            case "Resume": {
                await recordingClient?.resumeCloudRecording();
                break;
            }
            case "Stop": {
                await recordingClient?.stopCloudRecording();
                break;
            }
            case "Pause": {
                await recordingClient?.pauseCloudRecording();
                break;
            }
            case "Status": {
                break;
            }
            default: {
                await recordingClient?.startCloudRecording();
            }
        }
    };
    const onVideoCaptureChange = useCallback((payload) => {
        console.log("Change camera");
        if (payload.state === VideoCapturingState.Started) {
            setIsStartedVideo(true);
        } else {
            setIsStartedVideo(false);
        }
    }, []);

    useEffect(() => {
        zmClient.on("current-audio-change", onHostAudioMuted);
        zmClient.on("passively-stop-share", onPassivelyStopShare);
        zmClient.on("device-change", onDeviceChange);
        zmClient.on("recording-change", onRecordingChange);
        zmClient.on("dialout-state-change", onDialOutChange);
        zmClient.on("video-capturing-change", onVideoCaptureChange);
        return () => {
            zmClient.off("current-audio-change", onHostAudioMuted);
            zmClient.off("passively-stop-share", onPassivelyStopShare);
            zmClient.off("device-change", onDeviceChange);
            zmClient.off("recording-change", onRecordingChange);
            zmClient.off("dialout-state-change", onDialOutChange);
            zmClient.off("video-capturing-change", onVideoCaptureChange);
        };
    }, [
        zmClient,
        onHostAudioMuted,
        onPassivelyStopShare,
        onDeviceChange,
        onRecordingChange,
        onDialOutChange,
        onVideoCaptureChange,
    ]);

    useUnmount(() => {
        if (isStartedAudio) {
            mediaStream?.stopAudio();
        }
        if (isStartedVideo) {
            mediaStream?.stopVideo();
        }
        if (isStartedScreenShare) {
            mediaStream?.stopShareScreen();
        }
    });

    useMount(() => {
        setIsSupportPhone(!!mediaStream?.isSupportPhoneFeature());
        setPhoneCountryList(mediaStream?.getSupportCountryInfo() || []);
    });

    const recordingButtons: RecordButtonProps[] = getRecordingButtons(recordingStatus, zmClient.isHost());

    useEffect(() => {
        if (props.triggerOnPatientConnect === true) {
            handleMuteStopAll();
        }

        if (props.triggerOnPatientConnect === false) {
            handleUnmuteAudio();
            handleShowVideo();
        }
    }, [props.triggerOnPatientConnect]);

    return (
        <div className={classNames("video-footer", className)}>
            {isAudioEnable && (
                <MicrophoneButton
                    isStartedAudio={isStartedAudio}
                    isMuted={isMuted}
                    isSupportPhone={isSupportPhone}
                    audio={audio}
                    phoneCountryList={phoneCountryList}
                    onPhoneCallClick={onPhoneCall}
                    onPhoneCallCancel={onPhoneCallCancel}
                    phoneCallStatus={getPhoneCallStatusDescription(phoneCallStatus)}
                    onMicrophoneClick={onMicrophoneClick}
                    onMicrophoneMenuClick={onMicrophoneMenuClick}
                    microphoneList={micList}
                    speakerList={speakerList}
                    activeMicrophone={activeMicrophone}
                    activeSpeaker={activeSpeaker}
                />
            )}
            <CameraButton
                isStartedVideo={isStartedVideo}
                onCameraClick={onCameraClick}
                onSwitchCamera={onSwitchCamera}
                onMirrorVideo={onMirrorVideo}
                cameraList={cameraList}
                activeCamera={activeCamera}
                isMirrored={isMirrored}
            />
            {sharing && (
                <ScreenShareButton
                    isStartedScreenShare={isStartedScreenShare}
                    onScreenShareClick={onScreenShareClick}
                />
            )}
            <Tooltip title={props.isFullScreen ? "Cerrar pantalla completa" : "Mostrar en pantalla completa"}>
                <Button
                    className={classNames("screen-share-button", {
                        "started-share": props.isFullScreen,
                    })}
                    icon={<IconFont type="icon-meeting" />}
                    // eslint-disable-next-line react/jsx-boolean-value
                    ghost={true}
                    shape="circle"
                    size="small"
                    onClick={() => props.setIsFullScreen(!props.isFullScreen)}
                />
            </Tooltip>
            <Tooltip title={"Cambiar pantalla"}>
                <Button
                    className={classNames("screen-share-button", {
                        "started-share": props.isChangeResolution,
                    })}
                    icon={<IconFont type="icon-spotlight" />}
                    ghost={true}
                    shape="circle"
                    size="small"
                    onClick={onCheckClick}
                />
            </Tooltip>
            {/* {recordingButtons.map((button: RecordButtonProps) => {
                return (
                    <RecordingButton
                        key={button.text}
                        onClick={() => {
                            onRecordingClick(button.text);
                        }}
                        {...button}
                    />
                );
            })} */}
            {/* {(zmClient.isManager() || zmClient.isHost())&& (
        <ScreenShareLockButton
        isLockedScreenShare={isLockedScreenShare}
        onScreenShareLockClick={()=>{
          mediaStream?.lockShare(!isLockedScreenShare);
          setIsLockedScreenShare(!isLockedScreenShare);
        }}
      />
      )} */}
        </div>
    );
};
export default VideoFooter;
